import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { DisplayDate } from 'owa-datetime';
import { getMonthRangeStart } from 'owa-datetime-utils';

/**
 * Get the start date for a given month
 * @param store The surface store
 * @returns The first date that should be displayed in a month view for this date range, i.e., for the
 * date range of Aug 1st - Aug 31st 2017, the returned date would be July 30th 2017 when first day of the week
 * is Sunday.
 */
export default function getDisplayMonthRangeStart(store: CalendarSurfaceStore): DisplayDate {
    return getMonthRangeStart(store.dateRange.start, store.userOptions.weekStartDay);
}
